import { render, staticRenderFns } from "./yeni.vue?vue&type=template&id=125e22bc&"
import script from "./yeni.vue?vue&type=script&lang=js&"
export * from "./yeni.vue?vue&type=script&lang=js&"
import style0 from "./yeni.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports